import React, { Component } from "react";
import fordStyles from "./SubNav.module.scss";
import lincolnStyles from "./SubNav-Lincoln.module.scss";
import Tabs from "@material-ui/core/Tabs";
import subNavFordStyles from "./subNavStyles";
import subNavLincolnStyles from "./subNavStyles-Lincoln";
import Tab from "@material-ui/core/Tab";
import { withTranslation } from "react-i18next";
import { MenuItem, Popover } from "@material-ui/core";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp";

class SubNavTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    };
  }

  handlePopOverClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handlePopOverClose = () => {
    this.setState({ anchorEl: null });
  };

  handleMenuItemClick = (event) => {
    this.handlePopOverClose();
    this.props.action(event, event.currentTarget.value);
  };

  render() {
    const styles = this.props.isFordBrand ? fordStyles : lincolnStyles;
    const subNavStyles = this.props.isFordBrand
      ? subNavFordStyles
      : subNavLincolnStyles;
    const open = Boolean(this.state.anchorEl);
    const arrow = {
      position: "absolute",
      paddingTop: "1px",
      display: "inline-block",
    };

    return (
      <div className={styles.root}>
        {this.props.tabs ? (
          <>
            <Tabs
              id="tabs"
              data-testid="tabs"
              value={
                this.props.selectedTab < this.props.visibleTabsCount
                  ? this.props.selectedTab
                  : false
              }
              onChange={this.props.action}
              TabIndicatorProps={{ style: subNavStyles.highlighted }}
              textColor="primary"
              variant={
                this.props.visibleTabsCount === 100 ? "scrollable" : "standard"
              }
              scrollButtons="off"
              classes={{
                flexContainer: styles.flexContainer,
                scrollable: styles.scrollable,
              }}
            >
              {this.props.tabs.map((item, index) => {
                function getStyle() {
                  if (item.hide) return subNavStyles.hide;
                  else if (item.disabledStyle) return subNavStyles.disabledTab;
                  else if (!item.enabled) return subNavStyles.disabledTab;
                  else if (this.props.selectedTab === index)
                    return subNavStyles.highlighted;
                  else return subNavStyles.tab;
                }

                return (
                  index < this.props.visibleTabsCount && (
                    <Tab
                      style={getStyle.call(this)}
                      id={"tab" + item.id}
                      key={index}
                      value={index}
                      data-testid={"tab" + item.id}
                      label={item.menuName}
                      disabled={!item.enabled}
                    />
                  )
                );
              })}
            </Tabs>
            {this.props.tabs.length > this.props.visibleTabsCount && (
              <>
                <div
                  data-testid="moreTab"
                  onClick={this.handlePopOverClick}
                  onMouseEnter={this.handlePopOverClick}
                  className={styles.moreTab}
                  style={
                    this.props.selectedTab >= this.props.visibleTabsCount
                      ? subNavStyles.highlighted
                      : subNavStyles.tab
                  }
                >
                  <span>
                    {this.props.t("SubNav.more")}
                    {this.state.anchorEl === null ? (
                      <KeyboardArrowDown style={arrow} />
                    ) : (
                      <KeyboardArrowUp style={arrow} />
                    )}
                  </span>
                </div>

                <Popover
                  open={open}
                  anchorEl={this.state.anchorEl}
                  onClose={this.handlePopOverClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  id="subNavMenuDropdown"
                  PaperProps={{ square: true }}
                >
                  {this.props.tabs.map((item, index) => {
                    return (
                      index >= this.props.visibleTabsCount && (
                        <MenuItem
                          onClick={this.handleMenuItemClick}
                          value={index}
                          key={index}
                          data-testid={"tab" + item.id}
                          id={"tab" + item.id}
                          style={
                            item.hide
                              ? subNavStyles.hide
                              : this.props.selectedTab === index
                              ? subNavStyles.highlightedMenuItem
                              : subNavStyles.menuItem
                          }
                          disabled={!item.enabled}
                        >
                          {item.menuName}
                        </MenuItem>
                      )
                    );
                  })}
                </Popover>
              </>
            )}
          </>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default withTranslation("emp")(SubNavTabs);
